import * as React from 'react';
import { StatusMessage } from '../../models';
import { Message as Msg, Icon } from 'semantic-ui-react';
import './MessageBanner.scss';

export interface MessageBannerProps {
  statusMessage?: StatusMessage;
  dismiss(): void;
}

export class MessageBanner extends React.Component<MessageBannerProps, {}> {
  componentDidUpdate() {
    const { statusMessage, dismiss } = this.props;
    if (statusMessage && statusMessage.timeout) {
      setTimeout(
        () => {          
          dismiss();
        },
        statusMessage.timeout);
    }

  }

  handleDismissBanner = () => {
    this.props.dismiss();
  }

  render() {
    const { statusMessage } = this.props;
    
    return (
      <div>
        {
          statusMessage ?

            <Msg
              success={statusMessage.status === 'success'}
              negative={statusMessage.status === 'error'}
              onDismiss={this.handleDismissBanner}
              icon={true}
              className="messageBanner"
            >
              <Icon name={statusMessage.icon} loading={statusMessage.status === 'request'} />
              <Msg.Content>
                <Msg.Header>{statusMessage.header}</Msg.Header>
                {statusMessage.message}
              </Msg.Content>
            </Msg>
            : null
        }
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MessageBanner/MessageBanner.tsx